<fgb-page-header
  [pageTitle]="'wallet.redeemed.title'"
  [showBalance]="false"
  [backButtonLink]="'/rewards/wallet'"
></fgb-page-header>
<div class="container">
  <div class="d-flex pt-lg-3 pb-lg-4 pb-3">
    <!-- Title -->
    <h5 class="m-0 wallet-redeemed-title text-white font-size-20 font-heading text-uppercase">
      {{ 'wallet.redeem.history' | translate }}
    </h5>
    <div class="back-button"></div>
  </div>
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list
        [redeemedItems]="walletItems.walletItemsClaimed"
        [pageSize]="0"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="no-items-container bg-primary">
    <div class="font-size-12 text-center py-3 text-white">
      {{ 'claimed.rewards.placeholder.description' | translate }}
    </div>
  </div>
</ng-template>
